(function () {
  'use strict';

  if (window.__entrupyUpsellInited) return;
  window.__entrupyUpsellInited = true;

  // ---- Configuration ------------------------------------------------------
  var PAID_VARIANT_ID    = 51772433891460;
  var FREE_VARIANT_ID    = 51772434284676;
  var FREE_THRESHOLD     = 150000;            // cents = $1,500.00
  var ELIGIBLE_TYPES     = ['bag', 'wallet']; // case-insensitive product_type match
  var DEBOUNCE_MS        = 200;
  var PROP_PARENT_KEY    = '_entrupy_for';

  // ---- State --------------------------------------------------------------
  var inFlight             = false;
  var pendingSync          = false;
  var debounceTimer        = null;
  var suppressObserver     = false;

  // Persistent across Prestige re-renders (DOM attrs get wiped)
  var sessionForceExpanded = false;
  var sessionDismissed     = false;
  var lastParentSig        = '';
  var prevAllCerted        = false;

  // ---- Helpers ------------------------------------------------------------
  function isCertItem(item) {
    return item.variant_id === PAID_VARIANT_ID || item.variant_id === FREE_VARIANT_ID;
  }
  function isEligibleParent(item) {
    if (isCertItem(item)) return false;
    var pt = (item.product_type || '').toLowerCase();
    return ELIGIBLE_TYPES.indexOf(pt) !== -1;
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c];
    });
  }
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function addCert(variantId, parentKey, parentTitle) {
    var props = {};
    props[PROP_PARENT_KEY] = parentKey;
    if (parentTitle) props['For'] = parentTitle;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
    });
  }
  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  // ---- Render -------------------------------------------------------------
  function buildExpandedHtml(parents, certByParentKey) {
    if (parents.length === 0) return '';

    var rows = parents.map(function (p) {
      var isFree     = p.price >= FREE_THRESHOLD;
      var variantId  = isFree ? FREE_VARIANT_ID : PAID_VARIANT_ID;
      var checkedAttr = certByParentKey[p.key] ? ' checked' : '';
      var priceLabel = isFree ? 'Included free' : '+$25';
      var title      = escapeHtml(p.product_title || p.title || 'item');

      return ''
        + '<label class="entrupy-row">'
        +   '<input type="checkbox" data-entrupy-checkbox'
        +     ' data-parent-key="' + escapeHtml(p.key) + '"'
        +     ' data-parent-title="' + escapeHtml(p.product_title || p.title || '') + '"'
        +     ' data-cert-variant="' + variantId + '"' + checkedAttr + '>'
        +   '<span class="entrupy-row-text">'
        +     '<span class="entrupy-row-title">Add Entrupy Authentication Certificate for ' + title + '</span>'
        +     '<span class="entrupy-row-price">' + priceLabel + '</span>'
        +   '</span>'
        + '</label>';
    }).join('');

    return ''
      + '<div class="entrupy-upsell-block">'
      +   '<button type="button" class="entrupy-dismiss-btn" data-entrupy-dismiss aria-label="Dismiss">×</button>'
      +   '<p class="entrupy-blurb">Add an Entrupy authentication certificate to verify your item.</p>'
      +   '<div class="entrupy-rows">' + rows + '</div>'
      + '</div>';
  }

  function buildCompactHtml(certedCount, totalCount) {
    var label;
    if (certedCount === totalCount) {
      label = 'Authentication added';
    } else {
      label = 'Authentication added for ' + certedCount + ' of ' + totalCount + ' items';
    }
    return ''
      + '<div class="entrupy-upsell-block entrupy-upsell-block--compact">'
      +   '<span class="entrupy-compact-check" aria-hidden="true">✓</span>'
      +   '<span class="entrupy-compact-text">' + escapeHtml(label) + '</span>'
      +   '<button type="button" class="entrupy-edit-link" data-entrupy-expand>Edit</button>'
      + '</div>';
  }

  function buildCompactDismissedHtml(count) {
    var label = count === 1
      ? 'Add Entrupy authentication'
      : 'Add Entrupy authentication for ' + count + ' items';
    return ''
      + '<button type="button" class="entrupy-upsell-block entrupy-upsell-block--compact entrupy-upsell-block--dismissed entrupy-compact-clickable" data-entrupy-expand>'
      +   '<span class="entrupy-compact-text">' + escapeHtml(label) + '</span>'
      +   '<span class="entrupy-compact-arrow" aria-hidden="true">+</span>'
      + '</button>';
  }

  function shouldRenderCompact(parents, certByParentKey, container) {
    if (parents.length === 0) return false;
    if (container.getAttribute('data-force-expanded') === '1') return false;
    return parents.every(function (p) { return certByParentKey[p.key]; });
  }

  function renderAll(parents, certByParentKey, cart) {
    var nodes = document.querySelectorAll('[data-entrupy-container]');
    if (nodes.length === 0) return;
    suppressObserver = true;
    // DOM reorder disabled: caused flip-flopping with Prestige re-renders. Items stay in cart order.
    // Reset session flags when the SET of eligible parents changes
    var sig = parents.map(function (p) { return p.key; }).sort().join('|');
    if (sig !== lastParentSig) {
      sessionForceExpanded = false;
      sessionDismissed     = false;
      lastParentSig        = sig;
    }
    var certedCount = parents.filter(function (p) { return certByParentKey[p.key]; }).length;
    var hasAnyCert = certedCount > 0;
    prevAllCerted = certedCount === parents.length && parents.length > 0;

    var html;
    if (parents.length === 0) {
      html = '';
    } else if (sessionForceExpanded) {
      // User explicitly clicked Edit/Add — overrides everything else
      html = buildExpandedHtml(parents, certByParentKey);
    } else if (hasAnyCert) {
      // Any number of certs (some or all) → compact "Authentication added" with Edit
      html = buildCompactHtml(certedCount, parents.length);
    } else if (sessionDismissed) {
      html = buildCompactDismissedHtml(parents.length);
    } else {
      html = buildCompactDismissedHtml(parents.length);
    }
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].innerHTML = html;
    }
    Promise.resolve().then(function () { suppressObserver = false; });
  }


  // ---- DOM reorder: place each cert next to its parent line item ---------
  function reorderCertLineItems(cart) {
    var items = cart.items;
    var surfaces = [
      { container: document.querySelector('.cart-drawer__items'), sel: 'line-item' },
      { container: document.querySelector('.order-summary__body'), sel: 'tr' }
    ];
    surfaces.forEach(function (s) {
      if (!s.container) return;
      var nodes = s.container.querySelectorAll(':scope > ' + s.sel);
      if (nodes.length !== items.length) return; // mismatch safety: skip
      var parentByKey = {};
      items.forEach(function (it, i) { if (!isCertItem(it)) parentByKey[it.key] = nodes[i]; });
      items.forEach(function (it, i) {
        if (!isCertItem(it)) return;
        var pk = it.properties && it.properties[PROP_PARENT_KEY];
        if (!pk) return;
        var parentEl = parentByKey[pk];
        var certEl = nodes[i];
        if (!parentEl || !certEl) return;
        certEl.classList.add('entrupy-cert-line');
        if (parentEl.nextSibling !== certEl) {
          parentEl.parentNode.insertBefore(certEl, parentEl.nextSibling);
        }
      });
    });
  }

  // ---- Sync ---------------------------------------------------------------
  function syncUpsell() {
    if (inFlight) { pendingSync = true; return; }
    inFlight = true;

    fetchCart()
      .then(function (cart) {
        var parents = cart.items.filter(isEligibleParent);
        var certs   = cart.items.filter(isCertItem);
        var keys    = {};
        parents.forEach(function (p) { keys[p.key] = true; });

        var orphans = certs.filter(function (c) {
          var pk = c.properties && c.properties[PROP_PARENT_KEY];
          return pk && !keys[pk];
        });

        var chain = Promise.resolve();
        orphans.forEach(function (o) {
          chain = chain.then(function () { return removeLine(o.key); });
        });

        return chain.then(function () {
          var hadOrphans = orphans.length > 0;
          var nextCart = hadOrphans ? fetchCart() : Promise.resolve(cart);
          return nextCart.then(function (c) { return { cart: c, hadOrphans: hadOrphans }; });
        });
      })
      .then(function (state) {
        var cart = state.cart;
        var parents = cart.items.filter(isEligibleParent);
        var certByParent = {};
        cart.items.filter(isCertItem).forEach(function (c) {
          var pk = c.properties && c.properties[PROP_PARENT_KEY];
          if (pk) certByParent[pk] = c;
        });
        renderAll(parents, certByParent, cart);

        if (state.hadOrphans) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function (err) {
        if (window.console) console.warn('[entrupy-upsell] sync error:', err);
      })
      .then(function () {
        inFlight = false;
        if (pendingSync) { pendingSync = false; scheduleSync(); }
      });
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncUpsell, DEBOUNCE_MS);
  }

  // ---- Checkbox handler (delegated, survives DOM replacements) ------------
  document.addEventListener('change', function (e) {
    var cb = e.target && e.target.closest && e.target.closest('[data-entrupy-checkbox]');
    if (!cb) return;

    var parentKey = cb.getAttribute('data-parent-key');
    var parentTitle = cb.getAttribute('data-parent-title') || '';
    var variantId = parseInt(cb.getAttribute('data-cert-variant'), 10);
    var wantsCheck = cb.checked;

    cb.disabled = true;

    var op;
    if (wantsCheck) {
      op = addCert(variantId, parentKey, parentTitle);
    } else {
      op = fetchCart().then(function (cart) {
        var cert = cart.items.find(function (i) {
          return isCertItem(i) && i.properties && i.properties[PROP_PARENT_KEY] === parentKey;
        });
        if (cert) return removeLine(cert.key);
      });
    }

    op
      .then(function () {
        // Cart state changed — auto-collapse so customer isn't blocked by the upsell
        sessionForceExpanded = false;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) {
        if (window.console) console.warn('[entrupy-upsell] checkbox op failed:', err);
        cb.checked = !wantsCheck;
      })
      .then(function () {
        cb.disabled = false;
      });
  });

  // ---- Edit link handler (expand collapsed view) --------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-entrupy-expand]');
    if (!btn) return;
    e.preventDefault();
    sessionForceExpanded = true;
    sessionDismissed     = false;
    scheduleSync();
  });

  // ---- Dismiss button handler --------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-entrupy-dismiss]');
    if (!btn) return;
    e.preventDefault();
    sessionDismissed     = true;
    sessionForceExpanded = false;
    scheduleSync();
  });

  // ---- Cart event listeners (no polling) ----------------------------------
  ['cart:refresh', 'cart:change', 'theme:cart:change', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, scheduleSync);
  });

  // ---- MutationObserver (catches manual line-item removal) ----------------
  var observer = new MutationObserver(function () {
    if (suppressObserver) return;
    scheduleSync();
  });

  function attachObservers() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
    var cartPage = document.querySelector('.shopify-section--main-cart, .cart-page');
    if (cartPage) observer.observe(cartPage, { childList: true, subtree: true });
  }

  // ---- Inject styles (once) -----------------------------------------------
  function injectStyles() {
    if (document.getElementById('entrupy-upsell-styles')) return;
    var style = document.createElement('style');
    style.id = 'entrupy-upsell-styles';
    style.textContent = ''
      + '.entrupy-upsell-block{padding:.85rem .75rem .65rem;border-top:1px solid #ccc;margin:0;}'
      + '.entrupy-blurb{font-size:.8125rem;line-height:1.4;margin:0 0 .55rem;padding-right:1.75rem;color:var(--text-color,#222);}'
      + '.entrupy-rows{display:flex;flex-direction:column;gap:.4rem;}'
      + '.entrupy-row{display:flex;align-items:flex-start;gap:.5rem;cursor:pointer;line-height:1.3;}'
      + '.entrupy-row input[type="checkbox"]{margin-top:.18rem;flex-shrink:0;cursor:pointer;}'
      + '.entrupy-row input[type="checkbox"]:disabled{cursor:wait;opacity:.6;}'
      + '.entrupy-row-text{display:flex;flex-direction:column;gap:.1rem;flex:1;}'
      + '.entrupy-row-title{font-size:.8125rem;line-height:1.35;}'
      + '.entrupy-row-price{font-size:.75rem;color:var(--text-subdued,#666);}'
      + '.entrupy-upsell-block--compact{display:flex;align-items:center;gap:.55rem;padding:.55rem .75rem;}'
      + '.entrupy-compact-check{display:inline-flex;align-items:center;justify-content:center;width:1rem;height:1rem;border-radius:50%;background:#1c7a3e;color:#fff;font-size:.7rem;flex-shrink:0;}'
      + '.entrupy-compact-text{font-size:.8125rem;flex:1;}'
      + '.entrupy-edit-link{font-size:.75rem;color:var(--text-subdued,#666);text-decoration:underline;background:none;border:none;padding:0;cursor:pointer;}'
      + '.entrupy-upsell-block{position:relative;}'
      + '.entrupy-dismiss-btn{position:absolute;top:.35rem;right:.45rem;width:2rem;height:2rem;background:none;border:none;padding:0;cursor:pointer;font-size:1.35rem;line-height:1;color:var(--text-subdued,#888);display:flex;align-items:center;justify-content:center;border-radius:50%;z-index:2;}'
      + '.entrupy-dismiss-btn:hover{color:#222;background:rgba(0,0,0,.05);}'
      + '.entrupy-upsell-block--dismissed .entrupy-compact-text{color:var(--text-subdued,#444);}'
      + '.entrupy-compact-clickable{display:flex;align-items:center;justify-content:space-between;width:100%;text-align:left;font-family:inherit;}'
      + '.entrupy-compact-clickable:hover{background:rgba(0,0,0,.025);}'
      + '.entrupy-compact-arrow{font-size:1.05rem;color:var(--text-subdued,#888);font-weight:400;line-height:1;margin-left:.5rem;}';
    document.head.appendChild(style);
  }

  function init() {
    injectStyles();
    attachObservers();
    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
